import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ControleSeapService } from '../controle-seap.service';

@Component({
  selector: 'app-lista-cursos',
  templateUrl: './lista-cursos.component.html',
  styleUrls: ['./lista-cursos.component.scss']
})
export class ListaCursosComponent implements OnInit {
  displayedColumns = ['name', 'time', 'see'];
  dataSource: any;
  cursos: any[] = [];
  constructor(private toastr: ToastrService, private router: Router, private server: ControleSeapService) { }

  ngOnInit() {
    this.init();
  }

  open(id) {
    this.router.navigate(['/controle-seap/add-curso', id])
  }

  newCurso() {
    this.router.navigate(['/controle-seap/add-curso'])
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  init() {
    this.cursos = [];
    this.server.getCursosStatic().then(res => {
      res.forEach(c => {
        const d = c.val();
        d.id = c.key;
        this.cursos.push(d);
      });

      this.cursos.sort((a, b) => a.name < b.name ? -1 : 1);
      this.dataSource = new MatTableDataSource(this.cursos);
    });
  }

  remove(id) {
    this.server.removeCursoById(id).then(res => {
      if(!res){
        this.toastr.error('Ocorreu um erro, tente novamente');
      } else {
        this.toastr.success('Curso removido com sucesso!');
      }
      
      this.init();
    }).catch(err => {
      this.toastr.error('Ocorreu um erro, tente novamente');
    })
    
  }

}
